export default __webpack_public_path__ + "static/media/6.e91f5d8c.mp4";